// Delays the invocation of the function parameter
// until the timeout parameter has elapsed
// Useful for: searching, key up, double-submit handling
export const debounce = <T extends Function>(func: T, timeout: number): T => {
    let timeoutId: number;

    return ((...args: Array<{}>): void => {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }

        timeoutId = window.setTimeout(func, timeout, ...args);
    }) as any; // tslint:disable-line no-any
};